import {Component, signal, ChangeDetectionStrategy} from '@angular/core';
import {ApiService} from '../_services/api.service';
import {Category} from '../_models/category';
import {lastValueFrom, Subscription} from 'rxjs';
import {Router} from '@angular/router';
import {FormHelperService} from './file-online-v2/services/form-helper.service';
import {FormDetail} from './file-online-v2/models/api/Form';

export enum FormsListState {
  loading,
  error,
  loaded
}

@Component({
    selector: 'app-forms',
    templateUrl: './forms.component.html',
    styleUrls: ['./forms.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormsComponent {
  status = false;
  CategoryItems: Category[];
  forms: FormDetail[];
  searchText = '';
  currentCategory = 0;
  subscription: Subscription;

  protected readonly FormsListState = FormsListState;
  statusPageState = signal(FormsListState.loading);

  constructor(protected apiService: ApiService,
              public router: Router,
              protected formHelper: FormHelperService) {
    this.loadData().then();
  }

  async loadData(): Promise<void> {
    this.statusPageState.set(FormsListState.loading);
    try {
      const [categories, forms] = await Promise.all([
        lastValueFrom(this.apiService.getCategories()),
        lastValueFrom(this.apiService.getAllForms())
      ]);

      this.CategoryItems = categories;
      this.forms = forms;
      this.statusPageState.set(FormsListState.loaded);
    } catch (e) {
      console.error(e);
      this.statusPageState.set(FormsListState.error);
    }
  }

  onClickRetry(): void {
    this.statusPageState.set(FormsListState.loading);
    this.loadData().then();
  }
}
